import { useEffect, useState } from "react"
import { useAuthcontext } from './useAuthcontext'

//firebase imports
import { auth, db } from "../firebase/config"
import { signInWithEmailAndPassword  } from "firebase/auth"
import { updateDoc, doc } from "firebase/firestore";

export const useLogin = () => {
    const[isCancelled, setIsCancelled] = useState(false)
    const[error,setError] = useState(null)
    const[ispending, setIspending] = useState(false)

    const { dispatch } = useAuthcontext()

    const login = async(email, password) => {
        setError(null)
        setIspending(true)
        try {
           let res = await signInWithEmailAndPassword(auth, email, password)

           //update online status
           const docRef = doc(db,'users',res.user.uid)
           await updateDoc(docRef,{online: true})

            //dispatch login action
            dispatch({ type: 'LOGIN', payload: res.user})
            if (!isCancelled) {
                setIspending(false)
                setError(null)
            }
        } catch (err) {
            if (!isCancelled) {
                console.log(err.message)
                setError(err.message)
                setIspending(false)
            }
            
        }
        
            
    }

    useEffect(() => {
        return () => setIsCancelled(true)
    },[])

    return{login, error, ispending}
}